"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var deriveOnClick = function deriveOnClick(onClick) {
  if (typeof onClick === 'function') {
    return onClick;
  }

  if (typeof onClick === 'string' && onClick !== '') {
    var onClickSelector = onClick;
    return function () {
      var _window, _window$document, _window$document$getE;

      return (_window = window) === null || _window === void 0 ? void 0 : (_window$document = _window.document) === null || _window$document === void 0 ? void 0 : (_window$document$getE = _window$document.getElementById(onClickSelector)) === null || _window$document$getE === void 0 ? void 0 : _window$document$getE.click();
    };
  }

  return undefined;
};

/**
 * @deprecated
 * ```
 * import Button from '@insided/control/uikit/Button'
 * ```
 */
var ButtonControl = function ButtonControl(props) {
  var _classNames;

  var customClass = props.class,
      className = props.className,
      disabled = props.disabled,
      fullWidth = props.fullWidth,
      icon = props.icon,
      onClick = props.onClick,
      title = props.title,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'secondary' : _props$variant,
      isLoading = props.isLoading,
      newStyle = props.newStyle,
      outlined = props.outlined,
      type = props.type,
      size = props.size,
      customClassName = props.customClassName;

  if (!icon && !title) {
    return null;
  }

  var derivedOnClick = deriveOnClick(onClick);
  var sharedClassNames = (0, _classnames.default)(className, customClass, customClassName);
  return (0, _preact.h)(_Button.default, {
    className: newStyle ? sharedClassNames : (0, _classnames.default)('button-control', sharedClassNames, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "button-control--".concat(variant), !outlined), (0, _defineProperty2.default)(_classNames, "button-control--".concat(variant, "--outlined"), outlined), (0, _defineProperty2.default)(_classNames, 'button-control--full-width', fullWidth), (0, _defineProperty2.default)(_classNames, 'button-control--icon', icon), _classNames)),
    oldStyle: !newStyle,
    isLoading: isLoading,
    onClick: derivedOnClick // @ts-expect-error
    ,
    variant: variant,
    type: type,
    icon: icon,
    title: title,
    size: size,
    disabled: disabled,
    "data-element-name": props['data-element-name'],
    "data-track-type": props['data-track-type'],
    "data-qa": props['data-qa'],
    buttonRef: props.buttonRef
  });
};

var _default = ButtonControl;
exports.default = _default;